export default __webpack_public_path__ + "static/media/metamask-wallet.d9de41cb.jpg";